import { stringify } from "qs";
import request from "../../request";
import { url } from "../../service-utils";
import { GetQueryString } from "../../utils";

// 局端指标汇总
export async function getBureauNormSummary(params) {
  return request(
    `${url.activitySign}/activity/item/item-summary-edu?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 校端指标汇总
export async function getSchoolNormSummary(params) {
  return request(
    `${url.activitySign}/activity/item/item-summary?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 局端指标汇总详情
export async function getBureauNormSummaryDetail(params) {
  return request(
    `${url.activitySign}/activity/item/item-summary-detail-edu?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 校端指标汇总详情
export async function getSchoolNormSummaryDetail(params) {
  return request(
    `${url.activitySign}/activity/item/item-summary-detail?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 校端指标详情
export async function getSchoolNormDetail(params) {
  return request(
    `${url.activitySign}/activity/item/item-detail?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}
